'use strict';

angular.module('DoohApps').service('FileUpload', ['$http', '$q', 'DoohConfig', 'User',
    function ($http, $q, DoohConfig, User) {
        this.upload = function (config) {
            config.companyId = config.companyId || 0;
            let canceller = $q.defer();
            let formData = new FormData();
            let requestCancelled = false;
            formData.append('companyId', config.companyId);
            formData.append('file', config.file, config.fileName || config.file.name);
            formData.append('useFileNameInUpload', !!config.useFileNameInUpload)

            var headers = {
                'Content-Type': undefined,
                'CompanyID': User.company.id || 0,
            };

            var accessToken = localStorage['accessToken'];

            if (accessToken && accessToken != 'null') {
                headers.Authorization = 'Bearer ' + accessToken;
                headers.UsedTimeZone = localStorage['TimeZoneIANA'] || moment.tz.guess();
            }

            $http({
                method: 'POST',
                data: formData,
                url: DoohConfig.RestApiBaseURL + 'FileContainer/' + 'Upload',
                headers: headers,
                uploadEventHandlers: {
                    progress: function (e) {
                        config.onProgress(e.loaded * 100 / e.total, () => {
                            requestCancelled = true;
                            canceller.resolve('request cancelled');
                        })
                    }
                },
                timeout: canceller.promise
            }).then(res => config.onSuccess(res.data.Content), res => !requestCancelled && config.onError(res));
        };

        this.getFileUploadUrl = (successCallback, fileName) => successCallback(null, null);

        this.getAssetUploadUrl = (successCallback, asset, companyId) => successCallback(asset, null, null);
    }]);